import { useEffect, useState, useRef } from "react";
import {
  notify,
  dateFormatting,
  manageErrorLogs,
  getLocationCoordinates,
} from "../helpers/commonFunction";
import { messages } from "../helpers/messages";

const useCachedLocation = () => {
  const positionRef = useRef(null);
  const [position, setPosition] = useState(null);
  const [accuratePosition, setAccuratePosition] = useState(null);

  const fetchAndCacheLocation = async () => {
    try {
      const address = await getLocationCoordinates(true, true);
      positionRef.current = address;
      if (address?.latitude && address?.longitude) {
        setPosition(address);
      } else {
        setPosition(null);
      }
    } catch (error) {
      setPosition(null);
      manageLocationError(error);
      manageErrorLogs(error);
    }
  };

  const manageLocationError = (error) => {
    try {
      const locationError =
        JSON.parse(localStorage.getItem("locationError")) || null;
      const errorCount = locationError?.count || 0;
      const errorDate = dateFormatting(locationError?.date || new Date());
      const errormessage =
        error?.message &&
        error?.message === messages.errors.location_permission_issue
          ? messages.errors.location_denied
          : error?.message || messages.errors.location_denied;
      if (errorCount < 2) {
        notify(errormessage);
        const newLocationError = {
          count: errorCount + 1,
          date: new Date(),
        };
        localStorage.setItem("locationError", JSON.stringify(newLocationError));
      } else if (errorDate !== dateFormatting()) {
        notify(errormessage);
        const newLocationError = {
          count: 1,
          date: new Date(),
        };
        localStorage.setItem("locationError", JSON.stringify(newLocationError));
      }
    } catch (error) {
      console.log("manageLocationError", error);
    }
  };

  useEffect(() => {
    fetchAndCacheLocation();
    const interval = setInterval(fetchAndCacheLocation, 30000);
    return () => clearInterval(interval);
  }, []);

  return { position, accuratePosition };
};

export default useCachedLocation;
